import React, { FC, FormEventHandler, ReactElement } from "react";
import { Control, Controller } from "react-hook-form";
import { TextField, Stack, Box } from "@mui/material";
import { TFunction } from "i18next";

import { Button } from "@components/base";

export type MFAFormValues = {
  code: string;
};

export interface MFAForm {
  onSubmit: FormEventHandler<HTMLFormElement>;
  submitting: boolean;
  control: Control<{ code: string }>;
  qrCode: string;
  t: TFunction<"translation", undefined>;
}

const MFAForm: FC<MFAForm> = ({ onSubmit, submitting, control, t, qrCode }) => (
  <form onSubmit={onSubmit}>
    <Stack direction="column" rowGap={3}>
      <Box textAlign="center">
        <img src={qrCode} alt="QR" style={{ width: 200 }} />
      </Box>
      <Controller
        control={control}
        name="code"
        render={({
          field: { onBlur, onChange, name, value },
          fieldState: { error },
        }): ReactElement => (
          <TextField
            {...{ onBlur, onChange, name, value }}
            error={Boolean(error)}
            helperText={error?.message}
            placeholder={t("otp.code.title")}
            type="string"
            autoFocus
          />
        )}
      />

      <Button
        isLoading={submitting}
        disabled={submitting || !control._formState.isValid}
        size="medium"
        type="submit"
        variant="contained"
      >
        {t("Connect")}
      </Button>
    </Stack>
  </form>
);

export default MFAForm;
